var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7Star(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.3 48.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #231e49;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HOME_PAGE",
    "data-name": "HOME PAGE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "texto_dcha",
    "data-name": "texto dcha"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "8.59 39.72 16.52 26.42 2.03 20.97 17.37 18.88 12.6 4.15 23.79 14.84 32.33 1.93 30.96 17.35 46.38 15.97 33.46 24.51 44.15 35.71 29.42 30.93 27.34 46.28 21.89 31.78 8.59 39.72"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7Star);
export default __webpack_public_path__ + "static/media/7star.0bd5f4ecf1bd1538896ad97198229666.svg";
export { ForwardRef as ReactComponent };